<template>
  <component :is="tag"
  >{{text | toUpperCase}}</component>
</template>

<script>
export default {
  name: 'result-text',
  uit() {
    return [[
      'common',
      ['noResultsFound', '1ResultFound', 'nResultsFound']
    ]]
  },
  props: {
    tag: {
      type: String,
      default: 'span'
    },
    num: {
      type: [String, Number],
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    parsedNum: function() {
      return typeof this.num == Number 
        ? this.num 
        : parseInt(this.num, 10);
    },
    text: function() {
      if (this.parsedNum == 0) {
        return this.loading ? '' : this.$t('common.noResultsFound');
      } else if (this.parsedNum == 1) {
        return this.$t('common.1ResultFound');
      } else {
        return this.$t('common.nResultsFound', { n: this.parsedNum });
      }
    }
  }
}
</script>